module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[88]87.3d6b514.woff2";